module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dialog-table-panel background"
  }, [_c('div', {
    staticClass: "form-group nopadding"
  }, [_c('div', {
    staticClass: "input-group group"
  }, [_c('label', {
    staticClass: "comboBoxLabel"
  }, [_vm._v(_vm._s(_vm.lang.S0111) + ":")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualClient),
      expression: "actualClient"
    }],
    staticClass: "form-control nopadding comboBoxGroup",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.actualClient = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.loadPolicies()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "-1"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0112))]), _vm._v(" "), _vm._l((_vm.clients), function(client) {
    return _c('option', {
      key: client.ClientId,
      domProps: {
        "value": client.ClientId
      }
    }, [_vm._v("\n            " + _vm._s(client.ClientName) + "\n          ")])
  })], 2)])]), _vm._v(" "), (_vm.actualClient && _vm.actualClient != -1) ? _c('div', {
    staticClass: "dialog-table-panel"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table",
    staticStyle: {
      "overflow-y": "unset"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center w30"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0115))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center w70"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0172))])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar client-policies-table"
  }, [(_vm.surveys) ? _vm._l((_vm.surveys), function(property, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "td-cb-policies w30 moreheadroom"
    }, [_c('a', {
      staticClass: "table-header",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.togglePermitted(property)
        }
      }
    }, [_vm._v(_vm._s(property.surveyTitle))])]), _vm._v(" "), _c('td', {
      staticClass: "w70",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('div', {
      staticClass: "reset-this"
    }, [_c('treeselect', {
      attrs: {
        "placeholder": _vm.lang.S0041,
        "options": property.surveysQuestions,
        "auto-load-root-options": false,
        "multiple": true,
        "limit": 5,
        "searchable": true,
        "showCount": true,
        "flat": true,
        "valueFormat": "id",
        "showCountOf": "LEAF_DESCENDANTS",
        "disabled": true
      },
      model: {
        value: (property.SelectedItems),
        callback: function($$v) {
          _vm.$set(property, "SelectedItems", $$v)
        },
        expression: "property.SelectedItems"
      }
    })], 1)])])
  }) : _vm._e()], 2)])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-980576d0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserMgmt/SurveysQuestionsPoliciesControl.vue
// module id = 1712
// module chunks = 1